// extracted by mini-css-extract-plugin
export default {"collectionBlock":"yxIAC","title":"TR1We","titleThin":"eiApg","planets":"aR-vf","planet":"vo9nK","skeleton-progress":"nXHfW"};